export default "__VITE_ASSET__D4b5cLdx__"